import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import tvaMq from "./tvaMq";
import "./ml";
import VueSVGIcon from "vue-svgicon";
import "vue-svgicon/dist/polyfill";
import SocialSharing from "vue-social-sharing";
import VueLazyload from "vue-lazyload";
import Router from "vue-router";
import VueLazyLoadVideo from "vue-lazyload-video";
import VueScrollTo from "vue-scrollto";
import store from "./store";
import JsonViewer from "vue-json-viewer";

Vue.config.productionTip = false;
Vue.use(VueSVGIcon);
Vue.use(SocialSharing);
Vue.use(VueLazyload);
Vue.use(VueLazyLoadVideo);
Vue.use(Router);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 300,
  easing: "ease",
  offset: -100
});
Vue.use(tvaMq, {
  mobile: 768,
  tablet: 768,
  desktop: Infinity,
  large: Infinity
});
Vue.use(JsonViewer);

Vue.prototype.$retina = window.devicePixelRatio > 1;
Vue.prototype.$touchDevice = "ontouchstart" in document.documentElement;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
